import Cookies from "js-cookie";

// 是不是线上
let isRelease = process.env.NODE_ENV === "production";

// 线上和测试需要区分的key
function releaseKey(baseKey) {
  return isRelease ? baseKey : `dev_${baseKey}`;
}

const CookieKeys = {
  // 左侧菜单-全部应用缓存
  userAppMenu: releaseKey("userAppMenu2"),
  // 左侧菜单-用户选中记录
  userLeftMenuClick: releaseKey("userLeftMenuClick"),
  // 左侧菜单-用户选中记录
  toggle_menu: releaseKey("toggle_menu"),
  // start 891 反爬信息记录所需Cookie
  // 登录来源
  login_source: "source",
  // 登录时间
  login_time: "login_time",
  // 登录IP
  login_ip: "login_ip",
  // 浏览器代理信息
  useragent_hash: "useragent_hash",
  // end
  // 模拟登陆 = 1
  cookie_insert_log: releaseKey("cookie_insert_log"),
  // 手机查看详情的二维码
  qrDetail: releaseKey("qrDetail"),
  // 新手任务列表图标显隐状态
  newbie_task: releaseKey("qlm_newbie_task"),
  // 新手引导蒙层
  newbie_guide: releaseKey("qlm_newbie_guide"),
  // 帮助中心是否第一次完成所有任务
  help_center_guide: releaseKey("qlm_help_center_guide"),
  // 老用户第一次进入用户中心主动显示帮助中心
  old_user_center: releaseKey("qlm_old_user_center"),
  // 搜索专区智能订阅器弹窗
  do_not_disturb_smart_subscribe_id_list: releaseKey("do_not_disturb_smart_subscribe_id_list"),
  // 导出数量提示（一天一次）
  export_num_tip: releaseKey("qlm_export_num_tip"),
  // 搜索记录
  historyItemsNew: releaseKey("historyItemsNew"),
  //用户名
  qlm_username: "qlm_username",
  //用户密码
  qlm_password: "qlm_password",
  //登录后返回的地址
  backUrl: "backUrl",
  //用户信息
  userInfo: "userInfo",
  //Token信息
  xAuthToken: "xAuthToken",
  //滑动验证信息
  accessCaptchaPermission: "accessCaptchaPermission",
};

export { CookieKeys, Cookies };
